<template>
    <div class="pt-[20px] pr-[0px] bg-[#ededed]">
        <div class="max-w-[1400px] w-full container mx-auto">
            <div class="lg:pt-[60px] pr-[20px] pb-[2%] pl-[10px] max-w-[1400px]">
                <contactsNavigation />
            </div>
        </div>
    </div>
    <div class="max-w-[1400px] w-full container mx-auto">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
        <div class="pt-[30px] pr-[20px] pb-[40px] pl-[10px] max-w-[1400px]">
            <FullButton
                @click="createNewContact()"
                width="100"
                title=" Neue Kontakt erstellen +"
                colour="white"
                data-cy="create_contact_button"
            />
            <h2 class="text-left text-2xl font-light my-[3%]">
                <strong>Liste aller Kontakte</strong>
            </h2>
            <v-card class="w-full mx-auto" color="grey-lighten-3">
                <v-card-text>
                    <v-text-field
                        :loading="loading"
                        density="comfortable"
                        type="input"
                        @input="search()"
                        variant="solo"
                        label="Kontakt suchen"
                        title="Person oder Organisation eingeben"
                        autofocus
                        v-model="searchTerm"
                        append-inner-icon="mdi-magnify"
                        single-line
                        hide-details
                        data-cy="search_contact_input"
                    ></v-text-field>
                </v-card-text>
            </v-card>
            <ContactsTable
                :load="fetchContactsLimit"
                :duplicateMethod="duplicateContact"
                :deleteMethod="deleteContact"
                :selectMethod="selectContact"
                :hasActions="true"
                :contacts="contacts"
                :contactsCount="50"
            />
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { ref } from 'vue'
    import contactsNavigation from '@/components/SubNavigations/TheContactsNavigation.vue'
    import FullButton from '@/components/Buttons/FullButton.vue'
    import ContactsTable from '@/components/Contacts/ContactsTable.vue'
    import useContactStore from '@/utils/useContactStore'
    import router from '@/router'
    import { Contact } from '@/model/types'

    const {
        selectedContact,
        contacts,
        loading,
        fetchContacts,
        fetchContactsSearch,
        fetchContactsLimit,
        deleteContact,
        duplicateContact,
    } = useContactStore()

    const searchTerm = ref('')

    // Fetch offers on component mount
    async function fetchDataOnMounted() {
        await fetchContacts({ limit: 50, offset: 0, filter: '' })
    }

    fetchDataOnMounted()

    // functions defined and used here

    function search() {
        fetchContactsSearch({ limit: 50, offset: 0, filter: searchTerm.value })
    }

    // functions exported

    function selectContact(contact: Contact) {
        selectedContact.value = contact

        router.push('/contacts/edit/' + contact.contactId)
    }

    function createNewContact() {
        selectedContact.value = {}
        selectedContact.value.person = {}
        selectedContact.value.organisation = {}
        selectedContact.value.billing = {}

        router.push('/contacts/edit/0')
    }

    //breadcrumbs

    const breadcrumbs = [
        {
            title: 'Adressbuch',
            disabled: false,
            href: 'contacts',
        },
    ]
</script>
